import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SimpleTextPopupComponent } from '../simple-text-popup/simple-text-popup.component';

@Component({
    selector: 'bdo-large-popup',
    templateUrl: '../simple-text-popup/simple-text-popup.component.html',
    styleUrls: ['./large-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LargePopupComponent extends SimpleTextPopupComponent {

  @Input() closeButtonModifier: string = '--white-large';


}
